export const theme = {
  colors: {
    primary: {
      main: '#0ea466',
      dark: '#008F4C',
      light: '#00EB89',
      superLight: '#CCFFEA',
      extraLight: '#E6FFF4',
    },
    secondary: {
      accent: '#6FDCC8',
      warm: '#fef9f6',
    },
    text: {
      black: '#140900',
      darkGray: '#504D49',
      gray: '#87817A',
      lightGray: '#d6d6d9',
    },
    neutral: {
      100: '#F5F5F5',
      200: '#E5E5E5',
      300: '#D4D4D4',
      400: '#A3A3A3',
      500: '#737373',
      600: '#525252',
      700: '#404040',
      800: '#262626',
      900: '#171717',
    },
    status: {
      danger: '#FF3312',
      warning: '#FFA500',
      info: '#3B82F6',
      success: '#0ea466',
    },
    white: '#FFFFFF',
  },
  fonts: {
    primary: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    secondary: "'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  fontWeights: {
    light: 200,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    black: 900,
  },
  fontSizes: {
    xs: '0.75rem',     // 12px
    sm: '0.875rem',    // 14px
    base: '1rem',      // 16px
    lg: '1.125rem',    // 18px
    xl: '1.25rem',     // 20px
    '2xl': '1.5rem',   // 24px
    '3xl': '1.875rem', // 30px
    '4xl': '2.25rem',  // 36px
    '5xl': '3rem',     // 48px
    '6xl': '3.75rem',  // 60px
  },
  borderRadius: {
    small: '8px',
    medium: '16px',
    large: '24px',
    full: '9999px',
  },
  shadows: {
    small: '0 2px 8px rgba(0, 0, 0, 0.06)',
    medium: '0 4px 20px rgba(0, 0, 0, 0.08)',
    large: '0 8px 40px rgba(0, 0, 0, 0.12)',
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1280px',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    xxxl: '64px',
  },
  transitions: {
    fast: '200ms ease-in-out',
    normal: '300ms ease-in-out',
    slow: '400ms ease-in-out',
  },
  zIndex: {
    base: 0,
    dropdown: 100,
    sticky: 200,
    overlay: 300,
    modal: 400,
    toast: 500,
  },
} as const;

export type Theme = typeof theme;
